import { ToastService } from '@tc-angular/design-system';
import { ObservabilityFacade } from 'src/app/core/services/facades';

export const GuardNavigationErrorSource = {
  paymentStepsBookingDataFlow: 'paymentStepsGuard.bookingDataFlow',
  paymentStepsMainTcFallback: 'paymentStepsGuard.mainTcFallbackFlow',
  billingQuoteEnquiries: 'billingGuard.prepareSessionDataForQuote.getDetailedEnquiries',
  billingBookingList: 'billingGuard.prepareSessionDataForBooking.getBookings',
  authGuardPaymentsLinkAccountStatus: 'authGuard.handlePaymentsLinkUrl.getAccountStatus',
} as const;

export type GuardNavigationErrorSourceValue =
  (typeof GuardNavigationErrorSource)[keyof typeof GuardNavigationErrorSource];

export const GuardNavigationFailureTestId = {
  paymentSteps: 'PaymentStepsGuardFailure',
  billing: 'BillingGuardFailure',
  authPaymentsLink: 'AuthGuardPaymentsLinkFailure',
} as const;

export function reportGuardNavigationFailure(
  error: unknown,
  errorSource: string,
  observabilityFacade: ObservabilityFacade,
  toastService: ToastService,
  testId: string,
): void {
  observabilityFacade.logError({
    error: error instanceof Error ? error : new Error('Route guard blocked navigation'),
    attributes: { errorSource },
  });

  toastService.open({
    variant: 'error',
    title: 'error.oops',
    description: 'error.somethingWentWrong',
    duration: 2000,
    testId,
  });
}
